import { Injectable } from '@angular/core';
import { CacheManagementService } from './cache-management.service';
import { TranslateService } from '@ngx-translate/core';
import { AsyncSubject } from 'rxjs';
import { StaffBasicInfo } from '@core/models/global-entities/global-entities';
import { GatewaySignalrService } from './gateway-signalr.service';
import { AppFeatures } from '@core/library/app-settings';
import { UserAnalyticsService } from './user-analytics.service';

// Objective:
// - initialize cached user
// - store observable for cached user - this will be used to initialize translate service
// - store error after caching user so that it can be displayed when app has loaded
// - do core license check and store error
// - initialize KSV & KMT cache
// - store any cache errors

@Injectable({
  providedIn: 'root',
})
export class AppPreloaderService {
  public initializingUser$ = new AsyncSubject<StaffBasicInfo>();
  initializingConfigError?: Error;
  initializingUserError?: Error;
  initializingCacheError?: Error;

  constructor(
    private cacheManagementService: CacheManagementService,
    private gatewaySignalR: GatewaySignalrService,
    private analytics: UserAnalyticsService
  ) {
    console.log('AppPreloaderService:Init');
  }

  updateCurrentUser() {
    return this.cacheManagementService.initializeUser().then(
      (resp) => {
        this.analytics.updateUserProperties(resp);
        this.initializingUser$.next(resp);
        this.initializingUser$.complete();
      },
      (err) => {
        this.initializingUser$.error(err);
      }
    );
  }

  updateConfig() {
    return this.cacheManagementService
      .initializeConfig()
      .catch((err) => (this.initializingConfigError = err));
  }

  updateCaches() {
    return this.cacheManagementService
      .initializeCache()
      .catch((err) => (this.initializingCacheError = err));
  }

  updateTranslations(translateService: TranslateService) {
    return new Promise((resolve, reject) => {
      const loggedInUser = this.cacheManagementService.LoggedInUser;
      const languageCode = loggedInUser ? loggedInUser.LanguageCode : 'en-GB';
      translateService.use(languageCode).subscribe(resolve, (err) => {
        console.error(`${languageCode}:`, err);
        reject('TRANSLATE_ERR');
      });
    });
  }

  startSocketConnection() {
    this.gatewaySignalR.init();
  }
}
